import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "search-by-scan" }
const _hoisted_2 = { class: "button-scan-parent" }
const _hoisted_3 = { class: "button-scan" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "search-by-pnr" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "search-by-detail" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SFSQRCodeScanner = _resolveComponent("SFSQRCodeScanner")!
  const _component_SFSLaserScanner = _resolveComponent("SFSLaserScanner")!
  const _component_StyledSearchOption = _resolveComponent("StyledSearchOption")!

  return (_openBlock(), _createBlock(_component_StyledSearchOption, { class: "search-option" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "laser-scan",
              onClick: _cache[0] || (_cache[0] = () => (_ctx.laserVisible = true))
            }, [
              _createElementVNode("img", { src: `/${'images/laser.png'}` }, null, 8, _hoisted_4)
            ]),
            _hoisted_5,
            _createElementVNode("div", {
              class: "camera-scan",
              onClick: _cache[1] || (_cache[1] = () => (_ctx.scanVisible = true))
            }, [
              _createElementVNode("img", { src: `/${'images/camera.png'}` }, null, 8, _hoisted_6)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateStep('PNR')))
        }, [
          _createElementVNode("span", {
            innerHTML: _ctx.groundHandlerMessage?.search_and_select_pax.SFS_LANG_ROW_2
          }, null, 8, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateStep('NAME')))
        }, [
          _createElementVNode("span", {
            innerHTML: _ctx.groundHandlerMessage?.search_and_select_pax.SFS_LANG_ROW_3
          }, null, 8, _hoisted_10)
        ])
      ]),
      _createVNode(_component_SFSQRCodeScanner, {
        visible: _ctx.scanVisible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scanVisible) = $event)),
        onScanned: _ctx.handleScan
      }, null, 8, ["visible", "onScanned"]),
      _createVNode(_component_SFSLaserScanner, {
        visible: _ctx.laserVisible,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.laserVisible) = $event)),
        onScanned: _ctx.handleScan
      }, null, 8, ["visible", "onScanned"])
    ]),
    _: 1
  }))
}